import { z } from 'zod';
export const paginareSchema = z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(200).default(50),
});
export const uuidSchema = z.string().uuid();
export const clientFilterSchema = z.object({
    search: z.string().optional(),
    tip: z.enum(['PF', 'PJ']).optional(),
    status: z.enum(['activ', 'inactiv']).optional(),
    ...paginareSchema.shape,
});
export const loginSchema = z.object({
    username: z.string().min(1),
    password: z.string().min(1),
});
//# sourceMappingURL=index.js.map